import React from 'react'
import { Center, Divider, Text, Box, Container, SimpleGrid, Card, Image, Stack, CardBody, Tag, Heading, CardFooter, ButtonGroup, Button } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { BsGithub } from 'react-icons/bs';
import projectsJson from '../update/projects.json';
export default function Projects() {

    console.log(projectsJson);

    const projectCardGetter = (data) => (
        <Card width='100%'>
            <CardBody>
                <Image
                    src={data.projectCover}
                    alt={data.projectTitle}
                    borderRadius='md'
                    height={"200px"}
                    width={"100%"}
                    objectFit={"cover"}
                    className="project_cover"
                />
                <Stack mt='3'>
                    <Heading size='md' fontFamily={"inherit"} fontWeight={"medium"}>{data.projectTitle}</Heading>
                    <Text>
                        {data.projectDesc}
                    </Text>
                </Stack>
                {data.techUsed.map((tag) => (
                    <Tag mt={3} variant='subtle' colorScheme='cyan' mr={2}>
                        {tag}
                    </Tag>
                ))}
            </CardBody>
            <Divider />
            <CardFooter>
                <ButtonGroup spacing='2'>
                    <a href={data.githubRepo} target="_blank" rel="noreferrer">
                        <Button variant='solid' colorScheme='cyan' fontWeight={"thin"} leftIcon={<BsGithub />}>
                            GitHub
                        </Button>
                    </a>
                </ButtonGroup>
            </CardFooter>
        </Card>
    )
    return (
        <div data-aos="fade-up">
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                <Center height='50px' mt={3}>
                    <Divider orientation='vertical' className='vertical_divider' />
                </Center>
                <Text fontSize={"2xl"}
                    bgGradient='linear(to-l,#6dd5ed,#2193b0)'
                    bgClip='text'
                    fontWeight={"semibold"}
                >
                    Recent Projects
                </Text>
            </Box>
            <Container mt={3} maxW={"5xl"}>
                <SimpleGrid columns={{ base: 1, sm: 1, md: 2, lg: 3 }} spacing={3}>
                    {
                        projectsJson.map((e) => (
                            projectCardGetter(e)
                        ))
                    }
                </SimpleGrid>
                <Box display={"flex"} justifyContent={"flex-end"}>
                    <a href='https://github.com/aryamitra06?tab=repositories' target={"_blank"} rel="noreferrer">
                        <Button rightIcon={<ArrowForwardIcon />} colorScheme='teal' variant='outline' fontWeight={"thin"} mt={3}>
                            View More
                        </Button>
                    </a>
                </Box>
            </Container>
        </div>
    )
}
